module.exports = __webpack_public_path__ + "img/FotoMo13.750c56b4.png";